<template>
  <div class="navMenu">
    <el-scrollbar>
      <el-menu
        style="height: 100%"
        :collapse="isCollapse"
        :default-active="ActiveRoute"
        class="el-menu-vertical-demo"
        background-color="#1B2A42"
        text-color="#fff"
        active-text-color="#ffffff"
        :unique-opened="true"
        :router="LeftRoute"
      >
        <el-menu-item class="navMenu-left">
          <img :src="imgLogo" />
        </el-menu-item>
        <template v-for="item in leftMenuList" class="navMenu-menu">
          <el-menu-item
            v-if="!item.children"
            :index="item.path"
            :key="item.path"
            ><div class="center-name">
              <img
                class="name-img"
                :src="
                  item.icon &&
                  require('../../assets/images/' + item.icon + '.png')
                "
              />{{ $t("NavMenu." + item.meta.title) }}
            </div>
          </el-menu-item>
          <el-submenu v-else :index="item.path" :key="item.path">
            <template slot="title">
              <div class="center-name">
                <img
                  class="name-img"
                  :src="
                    item.icon &&
                    require('../../assets/images/' + item.icon + '.png')
                  "
                />{{ $t("NavMenu." + item.meta.title) }}
              </div>
            </template>
            <template v-for="items in item.children">
              <el-menu-item
                v-if="!items.children"
                :index="items.path"
                :key="items.path"
              >
                <div class="center-name">
                  {{ $t("NavMenu." + items.meta.title) }}
                </div>
              </el-menu-item>
              <el-submenu v-else :index="items.path" :key="items.path">
                <template slot="title">
                  <div class="center-name">
                    {{ $t("NavMenu." + items.meta.title) }}
                  </div>
                </template>
                <el-menu-item
                  v-for="second in items.children"
                  :index="second.path"
                  :key="second.path"
                >
                  <div class="center-name">
                    {{ $t("NavMenu." + second.meta.title) }}
                  </div>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-submenu>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { findID } from "@/utility/index.js";
export default {
  data() {
    return {
      leftMenuList: [],
      LeftRoute: true, 
      cookieRoute: [],
    };
  },
  created() {
    if (this.$router.options.routes[0].children) {
      this.cookieRoute = JSON.parse(
        JSON.stringify(this.$router.options.routes[0].children)
      );
    }
    this.imgLogo = sessionStorage.getItem("logo");
  },
  mounted() {
    this.getTree();
  },
  computed: {
    isCollapse() {
      return this.$store.state.menuTab.isCollapse;
    },
    ActiveRoute() {
      if (
        this.$route.path ==
        "/BackgroundSettings/DictionaryManaged/DictionaryItem"
      ) {
        return "/BackgroundSettings/DictionaryManaged";
      } else if(this.$route.path ==
        "/GovernmentRegulation/EnforcementNotes/NoteDetail") {
          return "/GovernmentRegulation/EnforcementNotes";
      }else {
        const route = this.$route;
        const { meta, path } = route;
        return path;
      }
    },
  },
  methods: {
    getTree() {
      let MenuPower = [];
      let tree = this.$router.options.routes[0].children;
      MenuPower = JSON.parse(sessionStorage.getItem("menu"));
      if (MenuPower) {
        MenuPower.map((item, index) => {
          findID(tree, item.path);
        });
      }
      this.leftMenuList.push({
        path: "/HomePage",
        name: "HomePage",
        icon: "homeicon",
        navShow: false,
        component: (resolve) => require(['../../views/HomePage' + sessionStorage.getItem('path') + '.vue'], resolve),
        meta: {
          title: "home",
        },
        
      });
      let child = [];
      let son = [];
      this.$router.options.routes[0].children && this.$router.options.routes[0].children.map((item, index) => {
          if (item.navShow) {
            if (item.children) {
              child = [];
              item.children &&
                item.children.map((t, k) => {
                  if (t.children) {
                    son = [];
                    t.children &&
                      t.children.map((j, r) => {
                        if (j.navShow) {
                          son.push(j);
                        }
                      });
                    if (son.length > 0) {
                      t.children = son;
                      child.push(t);
                    }
                  } else {
                    if (t.navShow) {
                      child.push(t);
                    }
                  }
                });
            }
            if (child.length > 0) {
              item.children = child;
            }
            this.leftMenuList.push(item);
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.navMenu {
  height: 100%;
  color: #fff;
  /deep/.el-menu {
    border: none;
    .navMenu-left {
      width: 100%;
      height: auto;
      text-align: center;
      margin: 20px 0;
      background-color: #1b2a42 !important;
      
      img {
        width:100%;
        height: 43px;
      }
    }
    .el-submenu.is-active.is-opened {
      .el-menu {
        .el-menu-item {
          background-color: rgba(3, 14, 32, 0.5) !important;
        }
        .el-menu-item.is-active {
          background-color: #409eff !important;
          border-bottom: none;
          font-weight: bold;
        }
      }
    }
    // .el-menu-item:nth-child(1).is-active {
    //   background-color: #1b2a42 !important;
    // }
    .el-menu-item.is-active {
      background-color: #409eff !important;
      border-bottom: none;
      font-weight: bold;
    }

    .center-name {
      .name-img {
        width: 18px;
        height: 18px;
        margin: -2px 12px 0 0;
      }
    }
    .el-submenu__icon-arrow {
      margin-top: -4px;
      color: #fff;
    }
  }
}
/deep/.el-menu--collapse {
  width: 40px !important;
  .el-menu-item,
  .el-submenu__title {
    padding: 0 0 0 10px !important;
  }
  .navMenu-left {
    padding: 0 !important;
    img {
      height: 43px;
    }
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>
